import { toast } from 'react-toastify';

/** API errors arrive as a string, an array of validation messages, or an object with `message`. */
function toText(message) {
  if (message == null) return '';
  if (Array.isArray(message)) {
    const parts = [...new Set(message.map((m) => toText(m)).filter(Boolean))];
    if (parts.length <= 1) return parts[0] || '';
    return parts.map((p) => (/[.!?]$/.test(p) ? p : `${p}.`)).join(' ');
  }
  if (typeof message === 'object') {
    return toText(message.message ?? message.error ?? '');
  }
  return String(message).trim();
}

export function showError(message) {
  const text = toText(message);
  if (!text) return;
  toast.error(text);
}

export function showSuccess(message) {
  const text = toText(message);
  if (!text) return;
  toast.success(text);
}

export function showInfo(message) {
  const text = toText(message);
  if (!text) return;
  toast.info(text);
}

export { toast };
